import {useAppContext} from "../components/AppContext";
import {Button, Card,Row, Col, Container, Form} from "react-bootstrap";
import {MachineParameter} from "../components/pages/operate_machine/MachineParameter";
import {BooleanMachineParameter} from "../components/pages/operate_machine/BooleanMachineParameter";
import {callMqttUpdateStatus} from "../lib/api/callMqttUpdateStatus";
import {useEffect, useState} from "react";
import {useAuth} from "../components/auth/AuthProvider";
import {SpaceSeparator} from "../components/ui/SpaceSeparator";
import {CognitoAuthContext} from "../components/cognito/CognitoAuthContext";
import { Authenticator } from '@aws-amplify/ui-react';
import { getCurrentTsString} from "../helpers/time/getCurrentTsString"
import {LoadingSpinner} from "../components/ui/LoadingSpinner";
import {getMachineStatus} from "../lib/api/getMachineStatus";
import {JsonPopup} from "../components/ui/JsonPopup";
import {ConfirmPanel} from "../components/ui/ConfirmPanel";
import {clearAlertNotificationsLog} from "../lib/api/clearAlertNotificationsLog";
import {ROUTES} from "../routes";
import {AlertNotificationsQueue} from "../components/simulator/AlertNotificationsQueue";

export const OperateMachine = () => {
    const {fakeMachine} = useAppContext();
    const {token} = useAuth();

    // simulator operations flags an variables
    const [lastRequestTS, setLastRequestTS] = useState();
    const [isSendingStatus, setIsSendingStatus] = useState(false);
    const [isLoadingStatus, setIsLoadingStatus] = useState(false);
    const [showClearLogConfirm, setShowClearLogConfirm] = useState(false);
    const [isCleaningLog, setIsCleaningLog] = useState(false);
    const [machineParameterSignal, setMachineParameterSignal] = useState(null);
    const [alertNotificationQueueSignal, setAlertNotificationQueueSignal] = useState(null);


    // Message variables
    const [ackToken, setAckToken] = useState("AAABBB");
    const [fwVer, setFwVer] = useState("10.0.0");
    const [mediaVer, setMediaVer] = useState("10.0.0");
    const [checkForUpdates, setCheckForUpdates] = useState(true);

    const [alertNotificationsLog, setAlertNotificationsLog] = useState(null);

    // counters read only
    const [dmk_0001, setDmk_0001] = useState(0);        // total processed liters
    const [dmk_0002, setDmk_0002] = useState(0);        // total processed liters current filters
    const [dmk_0003, setDmk_0003] = useState(0);        // total processed hot water liters
    const [dmk_0004, setDmk_0004] = useState(0);        // total dispensed drops a
    const [dmk_0005, setDmk_0005] = useState(0);        // total dispensed drops b
    const [dmk_0006, setDmk_0006] = useState(0);        // total dispensed drops c
    const [dmk_0007, setDmk_0007] = useState(0);        // total boiler time
    const [dmk_0008, setDmk_0008] = useState(0);        // total uv lamp time
    const [dmk_0009, setDmk_0009] = useState(0);        // Total processed water since last descaling milliliters
    const [dmk_000A, setDmk_000A] = useState(0);        // Last descaling timestamp (UNIX timestamp format)
    const [dmk_000B, setDmk_000B] = useState(0);        // Total processed milliliters with the current filter 1 (cold and hot)
    const [dmk_000C, setDmk_000C] = useState(0);        // Total processed flavored water milliliters
    const [dmk_000D, setDmk_000D] = useState(0);        // Total pump time (seconds)

    // maintenance read only
    const [dmk_0101, setDmk_0101] = useState(0);        // change filters timestamp
    const [dmk_0102, setDmk_0102] = useState(0);        // hot cleaning timestamp
    const [dmk_0103, setDmk_0103] = useState(0);        // flush timestamp
    const [dmk_0104, setDmk_0104] = useState(0);        // average flow rate
    const [dmk_0105, setDmk_0105] = useState(0);        // Timestamp of the next change filter 1 (UNIX timestamp format)

    // errors read only
    const [dmk_0201, setDmk_0201] = useState(0);        // error mask 1

    // containers read only
    const [dmk_0401, setDmk_0401] = useState(0);        // container a status
    const [dmk_0402, setDmk_0402] = useState(0);        // container a id
    const [dmk_0403, setDmk_0403] = useState(0);        // container a percent left
    const [dmk_0404, setDmk_0404] = useState(0);        // container b status
    const [dmk_0405, setDmk_0405] = useState(0);        // container b id
    const [dmk_0406, setDmk_0406] = useState(0);        // container b percent left
    const [dmk_0407, setDmk_0407] = useState(0);        // container c status
    const [dmk_0408, setDmk_0408] = useState(0);        // container c id
    const [dmk_0409, setDmk_0409] = useState(0);        // container c percent left
    const [dmk_040A, setDmk_040A] = useState(0);        // container Tag UID 1
    const [dmk_040B, setDmk_040B] = useState(0);        // container Tag UID 2
    const [dmk_040C, setDmk_040C] = useState(0);        // container Tag UID 3

    // settings read-write
    const [dmk_0501, setDmk_0501] = useState(0);        // timestamp
    const [dmk_0502, setDmk_0502] = useState(0);        // fill level 0
    const [dmk_0503, setDmk_0503] = useState(0);        // fill level 1
    const [dmk_0504, setDmk_0504] = useState(0);        // fill level 2
    const [dmk_0505, setDmk_0505] = useState(0);        // hot water temperature
    const [dmk_0506, setDmk_0506] = useState(0);        // flavor temperature
    const [dmk_0507, setDmk_0507] = useState(0);        // language
    const [dmk_0508, setDmk_0508] = useState(0);        // high tds warning enabled
    const [dmk_0509, setDmk_0509] = useState(0);        // flavor intensity
    const [dmk_050A, setDmk_050A] = useState(0);        // mineral intensity
    const [dmk_050B, setDmk_050B] = useState(0);        // hot cleaning interval
    const [dmk_050C, setDmk_050C] = useState(0);        // child mode enabled

    // Cloud settings
    const [dmk_0601, setDmk_0601] = useState(0);        // High TDS warning level

    // firmware and media version - read only
    const [dmk_0A00, setDmk_0A00] = useState(0);        // firmware version major
    const [dmk_0A01, setDmk_0A01] = useState(0);        // firmware version middle
    const [dmk_0A02, setDmk_0A02] = useState(0);        // firmware version minor
    const [dmk_0A03, setDmk_0A03] = useState(0);        // media version major
    const [dmk_0A04, setDmk_0A04] = useState(0);        // media version middle
    const [dmk_0A05, setDmk_0A05] = useState(0);        // media version minor
    const [dmk_0A06, setDmk_0A06] = useState(0);        // data model version

    // section descriptions
    const counter_vars = {
        "dmk_0001": [dmk_0001, setDmk_0001, "Tot. processed ml", "Total precessed milliliters (cold and hot)"],
        "dmk_000B": [dmk_000B, setDmk_000B, "Tot. precessed ml filter 1", "Total processed milliliters with the current filter 1 (cold and hot)"],
        "dmk_0002": [dmk_0002, setDmk_0002, "Tot. precessed ml filter 2", "Total processed milliliters with the current filter 2 (cold and hot)"],
        "dmk_0003": [dmk_0003, setDmk_0003, "Tot. precessed hot water milliliters", "Total processed hot water milliliters"],
        "dmk_0004": [dmk_0004, setDmk_0004, "Tot. drops a", "Total dispensed drops from Micropump A (each drop is 16 ul)"],
        "dmk_0005": [dmk_0005, setDmk_0005, "Tot. drops b", "Total dispensed drops from Micropump B (each drop is 16 ul)"],
        "dmk_0006": [dmk_0006, setDmk_0006, "Tot. drops c", "Total dispensed drops from Micropump C (each drop is 16 ul)"],
        "dmk_0007": [dmk_0007, setDmk_0007, "Tot. boiler time", "Total boiler time (seconds)"],
        "dmk_0008": [dmk_0008, setDmk_0008, "Tot. uv time", "Total UV lamp time (seconds)"],
        "dmk_0009": [dmk_0009, setDmk_0009, "Tot. wrt. since descling ml", "Total processed water since last descaling milliliters"],
        "dmk_000A": [dmk_000A, setDmk_000A, "Lst descaling Ts", "Last descaling timestamp (UNIX timestamp format)"],         // TODO convert into human
        "dmk_000C": [dmk_000C, setDmk_000C, "Tot processed ml flavored", "Total processed flavored water milliliters"],
        "dmk_000D": [dmk_000D, setDmk_000D, "Tot pump time s", "Total pump time (seconds)"],
    }

    const maintenance_vars = {
        "dmk_0101": [dmk_0101, setDmk_0101, "Change filters ts", "Timestamp of the next change filter 2 (UNIX timestamp format)", true],
        "dmk_0102": [dmk_0102, setDmk_0102, "Hot cleaning ts",  "Timestamp of the next hot cleaning (UNIX timestamp format)"],
        "dmk_0103": [dmk_0103, setDmk_0103, "Flush ts", "Timestamp of the next filter flush (UNIX timestamp format)"],
        "dmk_0104": [dmk_0104, setDmk_0104, "Avg flow rate", "Average flow rate in ml/min"],
        "dmk_0105": [dmk_0104, setDmk_0104, "Ts next change filter 1", "Timestamp of the next change filter 1 (UNIX timestamp format)"]
    }

    const errors_vars = {
        "dmk_0201": [dmk_0201, setDmk_0201, "Error mask 1", "Error mask 1"],
    }

    // 3XX field are machine only not sent to back-end

    const containers_vars = {
        "dmk_0401": [dmk_0401, setDmk_0401, "Container A status", "Container A status"],
        "dmk_0402": [dmk_0402, setDmk_0402, "Container A id", "Container A status"],
        "dmk_0403": [dmk_0403, setDmk_0403, "Container A percent left", "Container A contents left in %"],
        "dmk_0404": [dmk_0404, setDmk_0404, "Container B status", "Container B status"],
        "dmk_0405": [dmk_0405, setDmk_0405, "Container B id", "Container B ID"],
        "dmk_0406": [dmk_0406, setDmk_0406, "Container B percent left", "Container B contents left in %"],
        "dmk_0407": [dmk_0407, setDmk_0407, "Container C status", "Container C status"],
        "dmk_0408": [dmk_0408, setDmk_0408, "Container C id", "Container C ID"],
        "dmk_0409": [dmk_0409, setDmk_0409, "Container C percent left", "Container C contents left in %"],
        "dmk_040A": [dmk_040A, setDmk_040A, "Container Tag UID 1", "Container A UUID"],
        "dmk_040B": [dmk_040B, setDmk_040B, "Container Tag UID 2", "Container B UUID"],
        "dmk_040C": [dmk_040C, setDmk_040C, "Container Tag UID 3", "Container C UUID"],
    }

    const settings_vars = {
        "dmk_0501": [dmk_0501, setDmk_0501, "Timestamp", "Machine date/time (UNIX timestamp), write only"],
        "dmk_0502": [dmk_0502, setDmk_0502, "Fill level 0", "How much water will be dispensed (level 0) in ml"],
        "dmk_0503": [dmk_0503, setDmk_0503, "Fill level 1", "How much water will be dispensed (level 1) in ml"],
        "dmk_0504": [dmk_0504, setDmk_0504, "Fill level 2", "How much water will be dispensed (level 2) in ml"],
        "dmk_0505": [dmk_0505, setDmk_0505, "Hot water temp", "Hot water temperature (in °C)"],
        "dmk_0506": [dmk_0506, setDmk_0506, "Flavor temp", "Flavor temperature customization (in °C)"],
        "dmk_0507": [dmk_0507, setDmk_0507, "Language", "User interface language"],
        "dmk_0508": [dmk_0508, setDmk_0508, "High tds warning enabled", "High TDS warning"],
        "dmk_0509": [dmk_0509, setDmk_0509, "Flavor intensity", "Flavor intensity"],
        "dmk_050A": [dmk_050A, setDmk_050A, "Mineral intensity", "Mineral intensity"],
        "dmk_050B": [dmk_050B, setDmk_050B, "Hot cleaning interval", "Hot cleaning interval"],
        "dmk_050C": [dmk_050C, setDmk_050C, "Child mode enabled", "Child mode"]
    }

    const cloud_settings = {
        "dmk_0601": [dmk_0601, setDmk_0601, "High TDS warning level", "High TDS warning level"]

    }

    const firmware_vars = {
        "dmk_0A00": [dmk_0A00, setDmk_0A00, "Firmware ver. maj", "Firmware version major"],
        "dmk_0A01": [dmk_0A01, setDmk_0A01, "Firmware ver. mid", "Firmware version middle"],
        "dmk_0A02": [dmk_0A02, setDmk_0A02, "Firmware ver. min", "Firmware version minor"],
        "dmk_0A03": [dmk_0A03, setDmk_0A03, "Media ver. maj", "Media version major"],
        "dmk_0A04": [dmk_0A04, setDmk_0A04, "Media ver. mid", "Media version middle"],
        "dmk_0A05": [dmk_0A05, setDmk_0A05, "Media ver. min", "Media version minor"],
        "dmk_0A06": [dmk_0A06, setDmk_0A06, "Data model version", "Data model version"]
    }

    // 08XX are machine only


    // varibale key to its setter
    const statusSetters = {
        "0001": setDmk_0001,
        "0002": setDmk_0002,
        "0003": setDmk_0003,
        "0004": setDmk_0004,
        "0005": setDmk_0005,
        "0006": setDmk_0006,
        "0007": setDmk_0007,
        "0008": setDmk_0008,
        "0009": setDmk_0009,
        "000A": setDmk_000A,
        "000B": setDmk_000B,
        "000C": setDmk_000C,
        "000D": setDmk_000D,
        "0101": setDmk_0101,
        "0102": setDmk_0102,
        "0103": setDmk_0103,
        "0104": setDmk_0104,
        "0105": setDmk_0105,
        "0201": setDmk_0201,
        "0401": setDmk_0401,
        "0402": setDmk_0402,
        "0403": setDmk_0403,
        "0404": setDmk_0404,
        "0405": setDmk_0405,
        "0406": setDmk_0406,
        "0407": setDmk_0407,
        "0408": setDmk_0408,
        "0409": setDmk_0409,
        "040A": setDmk_040A,
        "040B": setDmk_040B,
        "040C": setDmk_040C,
        "0501": setDmk_0501,
        "0502": setDmk_0502,
        "0503": setDmk_0503,
        "0504": setDmk_0504,
        "0505": setDmk_0505,
        "0506": setDmk_0506,
        "0507": setDmk_0507,
        "0508": setDmk_0508,
        "0509": setDmk_0509,
        "050A": setDmk_050A,
        "050B": setDmk_050B,
        "050C": setDmk_050C,
        "0601": setDmk_0601,
        "0A00": setDmk_0A00,
        "0A01": setDmk_0A01,
        "0A02": setDmk_0A02,
        "0A03": setDmk_0A03,
        "0A04": setDmk_0A04,
        "0A05": setDmk_0A05,
        "0A06": setDmk_0A06
    }

    //////////////////////////////////////////////////////////////////////////////////  helpers
    const _forceIntOrBool = (v) => {
        let vi = parseInt(v);
        if (isNaN(vi)) {
            // console.log("v is: " + v);

            // check if is boolean
            try {
                if (v === true || v === false) {
                    return v;
                }

                if(v.toLowerCase() === "true" || v.toLowerCase() === "false") {
                    if (v.toLowerCase() === "true") {
                        return true;
                    }
                    else if (v.toLowerCase() === "false") {
                        return false;
                    }
                }
            } catch (e) {
                console.log(`Error parsing as integer value ${v}, forced at 0`);
                console.log(e);
                return 0;
            }

            console.log(`Error parsing as integer value ${v}, forced at 0`);
            return 0;
        }
        return vi;
    }


    //////////////////////////////////////////////////////////////////////////////////  page events

    useEffect(() => {
        if (fakeMachine && token) {
            loadMachineStatus();
        }

    }, [token, fakeMachine])


    //////////////////////////////////////////////////////////////////////////////////  handle current machine status

    // load machine status from database
    const loadMachineStatus = () => {
        // TODO set spinner when loading
        // console.log(">>>>> load machine status called");

        setIsLoadingStatus(true);
        setAlertNotificationsLog(null);
        setMachineParameterSignal("reset");     // reset components
        setAlertNotificationQueueSignal("reset");       // reload notification queue

        const uniqueId = fakeMachine["machineUniqueID"];
        getMachineStatus(token, uniqueId).then( data => {
            const sections = data.sections;
            //setStatusData(sections);
            // console.log(">> status received!");
            // console.log(sections)
            setCurrentStatus(sections);

            if (data.alertNotificationsLog) {
                setAlertNotificationsLog(data.alertNotificationsLog);
            }
        }).catch( (err) => {
            console.error(err);
        }).finally( () => {
            setIsLoadingStatus(false);
            setMachineParameterSignal(null);
            setAlertNotificationQueueSignal(null);
        })

    }

    // set current status on the interface
    const setCurrentStatus = (sections) => {
        // console.log(sections);
        sections.forEach((section) => {
            section["fields"].forEach((field) => {
                // console.log("field:"+field["key"]+" -> " + field["value"]);
                const fn = statusSetters[field["key"]];
                try {
                    fn(field["value"]);
                } catch (e) {
                    console.log("Error on key: " + field["key"]);
                    console.log(e);
                }

            })
        });

    }

    //////////////////////////////////////////////////////////////////////////////////  update machine status (MQTT)

    const _buildDatamodelDictForVars = (vars) => {
        var dct = {}

        Object.entries(vars).forEach(([key, value]) => {
            const k = key.replace("dmk_", "");
            dct[k] = _forceIntOrBool(value[0]);
        });
        return dct;
    }

    const _buildUpdatePayload = () => {
        const dataModel = Object.assign({},
            _buildDatamodelDictForVars(counter_vars),
            _buildDatamodelDictForVars(maintenance_vars),
            _buildDatamodelDictForVars(errors_vars),
            _buildDatamodelDictForVars(containers_vars),
            _buildDatamodelDictForVars(settings_vars),
            _buildDatamodelDictForVars(cloud_settings),
            _buildDatamodelDictForVars(firmware_vars),
        );

        const payload = {
            "data_model": dataModel,
            "ack_token": ackToken,
            "fw_ver": fwVer,
            "media_ver": mediaVer,
            "check_for_updates": _forceIntOrBool(checkForUpdates)
        }
        return payload;
    }

    const clickSendData = () => {
        setIsSendingStatus(true);
        const payload = _buildUpdatePayload();
        // console.log("> Sending update ")
        // console.log(payload);
        // console.log("<")
        callMqttUpdateStatus(token, fakeMachine.machineUniqueID, payload).then( data => {
            setLastRequestTS(getCurrentTsString());
            setIsSendingStatus(false);
            // console.log("> call sent");
            // console.log(data);
            setTimeout( () => {
                loadMachineStatus();
            }, 500);

        }).catch( error => {
            console.log(">>>>> error when sending update data via mqtt");
            console.log(error);
        })
    }

    //////////////////////////////////////////////////////////////////////////////////  Notifications log operations

    const clickClearAlertNotificationsLog = () => {
        // show the confirmation panel, if confirmed call confirmedClearAlertNotificationsLog
        setShowClearLogConfirm(true);
        setIsCleaningLog(true);
    };

    const confirmedClearAlertNotificationsLog = () => {
        // call the API
        setShowClearLogConfirm(false);
        clearAlertNotificationsLog(token, fakeMachine.machineUniqueID).then( (data) => {
            loadMachineStatus();
        }).catch( (error) => {
            console.log(error);
        }).finally( () =>{
            setIsCleaningLog(false);
            loadMachineStatus();

            setTimeout( () => {
                loadMachineStatus();
            }, 1500);
        });
    }

    //////////////////////////////////////////////////////////////////////////////////  Page template

    return (
        <>
            <h1>Operate machine</h1>
                <Authenticator>
                <CognitoAuthContext>
                    {fakeMachine &&
                    <>
                        <Row className="mb-2">
                            <Col>
                                <a href={ROUTES.PROVISION}>&lt;-- Back</a>
                            </Col>
                        </Row>


                        <div>Machine: {fakeMachine.machineUniqueID} &nbsp; &nbsp;
                            <LoadingSpinner loadingFlag={isSendingStatus}>
                                <Button onClick={clickSendData}>Send data (MQTT)</Button>
                            </LoadingSpinner>
                            &nbsp;
                            { lastRequestTS &&
                                <span className="status-update">Last request TS: {lastRequestTS}</span>
                            }

                            <LoadingSpinner loadingFlag={isLoadingStatus}>
                                <Button onClick={loadMachineStatus}>Reload Status</Button>
                            </LoadingSpinner>
                        </div>

                        <SpaceSeparator height={22}/>

                        <AlertNotificationsQueue signal={alertNotificationQueueSignal}/>



                        { alertNotificationsLog &&

                            <>
                                <SpaceSeparator height={22}/>

                                <Card>
                                    <Card.Body>
                                        <Card.Title>Alert notifications in machine record</Card.Title>
                                        <Container>
                                            <Row>
                                                <Col>
                                                    AlertNotificationsLog &nbsp;
                                                    <JsonPopup jsonData={alertNotificationsLog} buttonLabel={"Show"} /> &nbsp;
                                                    <ConfirmPanel
                                                        show={showClearLogConfirm}
                                                        title="Clear notifications log"
                                                        message="This action cannot be undone. Do you really want to delete?"
                                                        onConfirm={confirmedClearAlertNotificationsLog}
                                                        onCancel={() => {setShowClearLogConfirm(false); setIsCleaningLog(false)}}
                                                    />
                                                    <LoadingSpinner loadingFlag={isCleaningLog}>
                                                        <Button onClick={clickClearAlertNotificationsLog}>Clear LOG</Button>
                                                    </LoadingSpinner>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </Card.Body>

                                </Card>
                            </>


                        }

                        <SpaceSeparator height={22}/>

                        <Row>
                            <Col>
                                <Card>
                                    <Container>
                                        <Card.Title>Message variables</Card.Title>
                                        <Card.Body>
                                            <Form>
                                                <Row>
                                                    <MachineParameter
                                                        label={"ACK Token"}
                                                        name={"ackToken"}
                                                        variable={ackToken}
                                                        setter={setAckToken}
                                                    />

                                                    <MachineParameter
                                                        label={"Firmware Version"}
                                                        name={"fwVer"}
                                                        variable={fwVer}
                                                        setter={setFwVer}
                                                    />
                                                    <MachineParameter
                                                        label={"Media Version"}
                                                        name={"mediaVer"}
                                                        variable={mediaVer}
                                                        setter={setMediaVer}
                                                    />

                                                    <BooleanMachineParameter
                                                        label={"Check for updates"}
                                                        name={"checkForUpdates"}
                                                        variable={checkForUpdates}
                                                        setter={setCheckForUpdates}
                                                    />

                                                </Row>
                                            </Form>
                                        </Card.Body>
                                    </Container>
                                </Card>

                                <SpaceSeparator height={5}/>


                                <Card>
                                    <Container>
                                        <Card.Title>Counters</Card.Title>
                                        <Card.Body>
                                            <Form>
                                                <Row>
                                                    {
                                                        Object.keys(counter_vars).map((key, index) => (
                                                            <MachineParameter
                                                                key={key}
                                                                name={key}
                                                                label={counter_vars[key][2]}
                                                                variable={counter_vars[key][0]}
                                                                setter={counter_vars[key][1]}
                                                                color={"green"}
                                                                desc={counter_vars[key][3]}
                                                                signal={machineParameterSignal}
                                                            />
                                                        ))
                                                    }
                                                </Row>
                                            </Form>
                                        </Card.Body>
                                    </Container>
                                </Card>

                                <SpaceSeparator height={5}/>

                                <Card>
                                    <Container>
                                        <Card.Title>Maintenance</Card.Title>
                                        <Card.Body>
                                            <Form>
                                                <Row>
                                                    {
                                                        Object.keys(maintenance_vars).map((key, index) => (
                                                            <MachineParameter
                                                                key={key}
                                                                name={key}
                                                                label={maintenance_vars[key][2]}
                                                                variable={maintenance_vars[key][0]}
                                                                setter={maintenance_vars[key][1]}
                                                                color={"green"}
                                                                desc={maintenance_vars[key][3]}
                                                                signal={machineParameterSignal}
                                                            />
                                                        ))
                                                    }
                                                </Row>
                                            </Form>
                                        </Card.Body>
                                    </Container>
                                </Card>

                                <Card>
                                    <Container>
                                        <Card.Title>Errors</Card.Title>
                                        <Card.Body>
                                            <Form>
                                                <Row>
                                                    {
                                                        Object.keys(errors_vars).map((key, index) => (
                                                            <MachineParameter
                                                                key={key}
                                                                name={key}
                                                                label={errors_vars[key][2]}
                                                                variable={errors_vars[key][0]}
                                                                setter={errors_vars[key][1]}
                                                                color={"green"}
                                                                desc={errors_vars[key][3]}
                                                                signal={machineParameterSignal}
                                                            />
                                                        ))
                                                    }
                                                </Row>
                                            </Form>
                                        </Card.Body>
                                    </Container>
                                </Card>




                                <SpaceSeparator height={5}/>

                                <Card>
                                    <Container>
                                        <Card.Title>Containers</Card.Title>
                                        <Card.Body>
                                            <Form>
                                                <Row>
                                                    {
                                                        Object.keys(containers_vars).map((key, index) => (
                                                            <MachineParameter
                                                                key={key}
                                                                name={key}
                                                                label={containers_vars[key][2]}
                                                                variable={containers_vars[key][0]}
                                                                setter={containers_vars[key][1]}
                                                                color={"green"}
                                                                desc={containers_vars[key][3]}
                                                                signal={machineParameterSignal}
                                                            />
                                                        ))
                                                    }
                                                </Row>
                                            </Form>
                                        </Card.Body>
                                    </Container>
                                </Card>

                                <SpaceSeparator height={5}/>

                                <Card>
                                    <Container>
                                        <Card.Title>Settings</Card.Title>
                                        <Card.Body>
                                            <Form>
                                                <Row>
                                                    {
                                                        Object.keys(settings_vars).map((key, index) => (
                                                            <MachineParameter
                                                                key={key}
                                                                name={key}
                                                                label={settings_vars[key][2]}
                                                                variable={settings_vars[key][0]}
                                                                setter={settings_vars[key][1]}
                                                                color={"green"}
                                                                desc={settings_vars[key][3]}
                                                                signal={machineParameterSignal}
                                                            />
                                                        ))
                                                    }
                                                </Row>
                                            </Form>
                                        </Card.Body>
                                    </Container>
                                </Card>
                                <SpaceSeparator height={5}/>

                                <Card>
                                    <Container>
                                        <Card.Title>Cloud Settings</Card.Title>
                                        <Card.Body>
                                            <Form>
                                                <Row>
                                                    {
                                                        Object.keys(cloud_settings).map((key, index) => (
                                                            <MachineParameter
                                                                key={key}
                                                                name={key}
                                                                label={cloud_settings[key][2]}
                                                                variable={cloud_settings[key][0]}
                                                                setter={cloud_settings[key][1]}
                                                                color={"green"}
                                                                desc={cloud_settings[key][3]}
                                                                signal={machineParameterSignal}
                                                            />
                                                        ))
                                                    }
                                                </Row>
                                            </Form>
                                        </Card.Body>
                                    </Container>
                                </Card>
                                <SpaceSeparator height={5}/>

                                <Card>
                                    <Container>
                                        <Card.Title>Firmware</Card.Title>
                                        <Card.Body>
                                            <Form>
                                                <Row>
                                                    {
                                                        Object.keys(firmware_vars).map((key, index) => (
                                                            <MachineParameter
                                                                key={key}
                                                                name={key}
                                                                label={firmware_vars[key][2]}
                                                                variable={firmware_vars[key][0]}
                                                                setter={firmware_vars[key][1]}
                                                                color={"green"}
                                                                desc={firmware_vars[key][3]}
                                                                signal={machineParameterSignal}
                                                            />
                                                        ))
                                                    }
                                                </Row>
                                            </Form>
                                        </Card.Body>
                                    </Container>
                                </Card>

                            </Col>
                        </Row>
                    </>
                    }

                </CognitoAuthContext>
                </Authenticator>


        </>


    )
}
